import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useBackendApi } from '../../helpers/backendHelper';
import './Contracts.scss'; // Import SCSS file

const ContractsTable = () => {
  const [contracts, setContracts] = useState();
  const { platform } = useParams();
  const chainIdsToShow = [1, 8453];
  const backendHelper = useBackendApi();

  async function getProtocolMetadata(projectName) {
    try {
      const metadata = await backendHelper.mrep.getProtocolData(projectName);
      setContracts(metadata?.data?.contracts);
    } catch (error) {
      console.error('Error fetching protocol metadata:', error);
    }
  }

  useEffect(() => {
    if (platform) {
      getProtocolMetadata(platform);
    }
  }, [platform]);

  if (!contracts) return null;

  return (
    <div className='contracts-table'>
      <h2>Contracts for {platform}</h2>
      <div className='table-container'>
        <table>
          <thead>
            <tr>
              <th>Contract Name</th>
              <th>Chain ID</th>
              <th>Address</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(contracts || {})
              .flatMap(([contractName, chains]) =>
                chainIdsToShow
                  .filter(chainId => chains[chainId])
                  .map(chainId => ({
                    contractName,
                    chainId,
                    address: chains[chainId].address,
                  })),
              )
              .map(({ contractName, chainId, address }) => (
                <tr key={`${contractName}-${chainId}`}>
                  <td>{contractName}</td>
                  <td>{chainId}</td>
                  <td className='contract-address'>{address}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContractsTable;
